export default __webpack_public_path__ + "static/media/vijay.2113a095.jpg";